export default __webpack_public_path__ + "static/media/dribble.e09c6fcb.png";